import React, { useState } from 'react';
import { Briefcase, CheckSquare, CheckCircle2 } from 'lucide-react';

export const VocationalLivingModule: React.FC = () => {
  const [tasks, setTasks] = useState([
    { id: 1, text: 'Stocking Supermarket Shelves (Visual Categorization)', done: true },
    { id: 2, text: 'Operating Point-of-Sale Touchscreen Register', done: true },
    { id: 3, text: 'Folding & Packaging Retail Garments', done: false },
    { id: 4, text: 'Community Transit & Bus Pass Scanning', done: false }
  ]);
  const [savedMsg, setSavedMsg] = useState('');

  const toggleTask = (id: number) => {
    setTasks(prev => prev.map(t => t.id === id ? { ...t, done: !t.done } : t));
  };

  const handleSaveAssessment = () => {
    setSavedMsg('Vocational task-analysis score saved to student transition portfolio!');
    setTimeout(() => setSavedMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Adult Rehabilitation & Work Readiness
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Vocational & Independent Living Skills</h2>
          <p className="text-xs text-slate-500">Adult disability work readiness, task-analysis schedules, and community independence</p>
        </div>

        <button 
          onClick={handleSaveAssessment}
          className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <Briefcase className="w-4 h-4" />
          <span>Save Vocational Score</span>
        </button>
      </div>

      {savedMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {savedMsg}
        </div>
      )}

      <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
        <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
          <CheckSquare className="w-4 h-4 text-emerald-600" />
          Task Analysis Skill Checklist
        </h3>

        <div className="space-y-2 text-xs">
          {tasks.map(task => (
            <div key={task.id} onClick={() => toggleTask(task.id)} className="p-3 bg-white border rounded-xl flex items-center gap-3 cursor-pointer">
              <input 
                type="checkbox" 
                checked={task.done} 
                onChange={() => toggleTask(task.id)}
                className="rounded text-emerald-600 focus:ring-emerald-500" 
              />
              <span className={task.done ? 'font-bold text-slate-900' : 'text-slate-500'}>{task.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
